export const commonError = {
    header: "Your session has timed out",
    subheader: "Please login and re-start booking again.",
    image: {
        src: "https://onemg.gumlet.io/staging/dab5dec8-6f86-41f4-b27e-ab3db44088fa.svg",
        alt: "Session Expired",
        height: "246px",
        width: "252px",
    },
}

export const genericErrorMessage = "Something went wrong. Please try again later."

export const timeToSwitchStatus = 2500

export const BOOKING_STEPS = {
    REVIEW: "review",
    PACKAGE_SELECTION: "package_selection",
    PERSONAL_INFO: "personal_info",
    TEST_DETAILS: "path_radio_test_details",
}

const NAME_VALIDATION_REGEX = /^[a-zA-Z0-9+. ]+$/ //matches alphabets, numbers and .

export const PATIENT_FORM_FIELD_VALIDATION_CONFIG = {
    name: {
        validate: (value) => {
            const trimmedValue = value.trim()
            if (!NAME_VALIDATION_REGEX.test(trimmedValue))
                return { isError: true, errorMessage: "Only alphabets, digits and . are allowed" }
            if (trimmedValue.length >= 100) {
                return {
                    isError: true,
                    errorMessage: "Patient's name length should be less than 100",
                }
            }
            if (trimmedValue.length < 2) {
                return {
                    isError: true,
                    errorMessage: "Patient's name length should be more than 1",
                }
            }
            return {
                isError: false,
                errorMessage: "",
            }
        },
    },
}

// Keeping these here for now. Will move to BE after deciding on final structure for dynamic forms
export const REQUIRED_ERROR_MESSAGE = {
    corporate_identifier: "Please enter your SAP ID to continue",
    designation_level: "Please enter your designation to continue",
    dob: "Please enter your date of birth to continue",
    gender: "Please enter your gender to continue",
    name: "Please enter your name to continue",
    base_city: "Please enter your base city to continue",
}
